export enum OrderStatusEnum {
  PLACED = "placed",
  PROCESSING = "processing",
  PAID = "paid",
  SHIPPED = "shipped",
  DELIVERED = "delivered",
  CANCELLED = "cancelled",
  MISSED = "missed",
}
// export enum OrderStatusEnum {
//     PLACED = 'Placed',
//     PROCESSING = 'Processing',
//     PAID = 'Paid',
//     SHIPPED = 'Shipped',
//     DELIVERED = 'Delivered',
//     CANCELLED = 'Cancelled',
// }
